import { render, staticRenderFns } from "./UCIrvineChem1LDELN1FSQuantitativeObservations1.vue?vue&type=template&id=7c40f8f8&scoped=true&"
import script from "./UCIrvineChem1LDELN1FSQuantitativeObservations1.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineChem1LDELN1FSQuantitativeObservations1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40f8f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
